import { Avatar } from '../../Avatar'
import { Container } from '../Container'

import * as styles from './Avatars.module.css'

import UserIcon from '../../../icons/user.svg'

function Avatars() {
  const AVATAR_FIRST_COLOR = '#a0ba5b'
  const AVATAR_SECOND_COLOR = '#f9e86d'
  const AVATAR_THIRD_COLOR = '#9de0fc'
  const src =
    'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png'

  return (
    <>
      <Container label='Avatar, with image, sizes - 16px, 24px, 32px, 40px, 48px'>
        <Avatar className={styles.avatar} size={16} src={src} />
        <Avatar className={styles.avatar} size={24} src={src} />
        <Avatar className={styles.avatar} size={32} src={src} />
        <Avatar className={styles.avatar} size={40} src={src} />
        <Avatar className={styles.avatar} size={48} src={src} />
      </Container>
      <Container label='Avatar, with text, sizes - 16px, 24px, 32px, 40px, 48px'>
        <Avatar
          className={styles.avatar}
          color={AVATAR_FIRST_COLOR}
          size={16}
          text='User Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_FIRST_COLOR}
          size={24}
          text='User Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_FIRST_COLOR}
          size={32}
          text='User Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_FIRST_COLOR}
          size={40}
          text='User Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_FIRST_COLOR}
          size={48}
          text='User Name'
        />
      </Container>
      <Container>
        <Avatar
          className={styles.avatar}
          color={AVATAR_SECOND_COLOR}
          size={16}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_SECOND_COLOR}
          size={24}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_SECOND_COLOR}
          size={32}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_SECOND_COLOR}
          size={40}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_SECOND_COLOR}
          size={48}
          text='Name'
        />
      </Container>
      <Container>
        <Avatar
          className={styles.avatar}
          color={AVATAR_THIRD_COLOR}
          size={16}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_THIRD_COLOR}
          size={24}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_THIRD_COLOR}
          size={32}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_THIRD_COLOR}
          size={40}
          text='Name'
        />
        <Avatar
          className={styles.avatar}
          color={AVATAR_THIRD_COLOR}
          size={48}
          text='Name'
        />
      </Container>
      <Container label='Avatar, with default icon, sizes - 16px, 24px, 32px, 40px, 48px'>
        <Avatar Icon={UserIcon} className={styles.avatar} size={16} />
        <Avatar Icon={UserIcon} className={styles.avatar} size={24} />
        <Avatar Icon={UserIcon} className={styles.avatar} size={32} />
        <Avatar Icon={UserIcon} className={styles.avatar} size={40} />
        <Avatar Icon={UserIcon} className={styles.avatar} size={48} />
      </Container>
      <Container label='Avatar, group, sizes - 16px, 24px, 32px, 40px'>
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_FIRST_COLOR}
          size={16}
          text='user name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_SECOND_COLOR}
          size={16}
          text='user name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_THIRD_COLOR}
          size={16}
          text='user name'
        />
        <Avatar className={styles.avatarNegative} size={16} text='+99' />
      </Container>
      <Container>
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_FIRST_COLOR}
          size={24}
          text='user name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_SECOND_COLOR}
          size={24}
          text='user name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_THIRD_COLOR}
          size={24}
          text='user name'
        />
        <Avatar className={styles.avatarNegative} size={24} text='+99' />
      </Container>
      <Container>
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_FIRST_COLOR}
          size={32}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_SECOND_COLOR}
          size={32}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_THIRD_COLOR}
          size={32}
          text='name'
        />
        <Avatar className={styles.avatarNegative} size={32} text='+99' />
      </Container>
      <Container>
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_FIRST_COLOR}
          size={40}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_SECOND_COLOR}
          size={40}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_THIRD_COLOR}
          size={40}
          text='name'
        />
        <Avatar className={styles.avatarNegative} size={40} text='+99' />
      </Container>
      <Container>
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_FIRST_COLOR}
          size={48}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_SECOND_COLOR}
          size={48}
          text='name'
        />
        <Avatar
          className={styles.avatarNegative}
          color={AVATAR_THIRD_COLOR}
          size={48}
          text='name'
        />
        <Avatar className={styles.avatarNegative} size={48} text='+99' />
      </Container>
    </>
  )
}

export default Avatars
